import { Field, InputType, Int, ObjectType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import { DocumentAssetTypeEnum } from '../DocumentAssetTypeEnum'

@InputType()
export class AttachmentInput extends ActionArgs {
  @Field(() => String)
  code: string

  @Field(() => String)
  assetUrl: string

  @Field(() => String)
  fileId: string

  @Field(() => String, { nullable: true })
  title?: string
}

@InputType()
export class AttachAssetsArgs extends ActionArgs {
  @Field(() => [AttachmentInput])
  attachments: AttachmentInput[]
}

@ObjectType()
@InputType('AttachmentFailureInput')
export class AttachmentFailure {
  @Field(() => String)
  code: string

  @Field(() => DocumentAssetTypeEnum, { nullable: true })
  documentType?: DocumentAssetTypeEnum

  @Field(() => String)
  assetUrl: string

  @Field(() => String)
  errorMessage: string
}

@ObjectType()
@InputType('AttachAssetsResultInput')
export class AttachAssetsResult {
  @Field(() => Int)
  totalProcessed: number

  @Field(() => Int)
  succeededCount: number

  @Field(() => Int)
  failedCount: number

  @Field(() => [AttachmentFailure])
  failures: AttachmentFailure[]
}
